import React from "react";

const SuccessIcon = ({ size = 100, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1024 1024"
    version="1.1"
    width={size}
    height={size}
    fill="currentColor"
    {...props}
  >
    <path d="M722.500267 330.888533l-273.408 273.408-147.729067-147.729066a41.984 41.984 0 1 0-59.426133 59.426133l177.425066 177.493333a41.984 41.984 0 0 0 59.426134 0l303.138133-303.172266a41.984 41.984 0 1 0-59.392-59.426134z" />
    <path d="M78.506667 783.496533a508.279467 508.279467 0 0 0 319.0784 226.986667c133.188267 30.583467 270.301867 7.441067 386.116266-65.092267a508.279467 508.279467 0 0 0 226.986667-319.0784 508.279467 508.279467 0 0 0-65.058133-386.116266C848.554667 85.367467 681.710933 0.341333 511.214933 0.341333 418.474667 0.341333 324.608 25.531733 240.401067 78.301867A36.864 36.864 0 0 0 279.552 140.629333c204.561067-128.341333 475.477333-66.048 603.716267 138.6496a434.9952 434.9952 0 0 1 55.739733 330.5472 435.029333 435.029333 0 0 1-194.3552 273.134934 435.746133 435.746133 0 0 1-330.581333 55.773866 435.165867 435.165867 0 0 1-273.134934-194.3552 436.770133 436.770133 0 0 1-5.666133-456.055466 36.829867 36.829867 0 0 0-63.317333-37.546667A510.1568 510.1568 0 0 0 78.506667 783.530667z" />
  </svg>
);

export default SuccessIcon;
